// The one bit of auth wiring that's safe to load on the guest path: a
// plain env check, no supabase-js import. main.js uses this to decide
// whether to show the "Sign in" affordance at all and whether to lazily
// pull in the (heavier) auth chunk. See docs/auth-design.md.

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "";
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "";

/** True only when the frontend actually has Supabase credentials. When
 * false the game is guest-only and every auth affordance stays hidden —
 * exactly today's behaviour. */
export const authConfigured = Boolean(SUPABASE_URL && SUPABASE_ANON_KEY);

/** Cheap check for "this browser has a Supabase session persisted" —
 * supabase-js stores it under `sb-<ref>-auth-token`. Lets main.js eagerly
 * load the auth chunk for a returning signed-in player while a brand-new
 * guest still pays nothing until they click "Sign in". Never throws. */
export function hasPersistedSession() {
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith("sb-") && k.endsWith("-auth-token")) return true;
    }
  } catch {
    /* storage blocked — treat as no session */
  }
  return false;
}
